import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SharePointLink" */ './lazyIndex')
);

export const lazyTryProcessSharePointLink = new LazyImport(
    lazyModule,
    m => m.tryProcessSharePointLink
);

export const lazyTryUndoProcessSharePointLink = new LazyImport(
    lazyModule,
    m => m.tryUndoProcessSharePointLink
);

export const lazyDocLinkHadPreviewInfo = new LazyImport(lazyModule, m => m.docLinkHadPreviewInfo);
export const lazyForceGetWacInfoOperation = new LazyImport(
    lazyModule,
    m => m.forceGetWacInfoOperation
);

export const lazyGetValidDocLinkPreviewInfo = new LazyImport(
    lazyModule,
    m => m.getValidDocLinkPreviewInfo
);

export { previewLinkInSxS } from './actions/publicActions';
